import React, {useState} from "react";
import axios from "axios";
import "./Dictionary.css";
import Results from "./Results";
import Photos from "./Photos";

export default function Dictionary(props) {
    let [keyWord, setKeyword] = useState(props.defaultKeyword);
    let [results, setResults] = useState(null);
    let [loaded, setLoaded] = useState(false);
    let [photos, setPhotos] = useState(null);

    function handleDictionResponse(response) {
        console.log(response.data[0]);
        console.log(response.data[0].meanings[0].definitions[0].definition);
        setResults(response.data[0]);
    }

    function handlePexelsResponse(response) {
        
        console.log(response.data);
        setPhotos(response.data.photos);
    }

    function search(){
        // documentation: https://dictionaryapi.dev/
        let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${keyWord}`;
        axios.get(apiUrl).then(handleDictionResponse);
        //.catch(err => err)

        let pexelsApiKey = "563492ad6f9170000100000151fd2fac64d241aa8d93b12512b78b45";
        let pexelsApiUrl = `https://api.pexels.com/v1/search?query=${keyWord}&per_page=6`;
        let headers = {"Authorization" : `Bearer ${pexelsApiKey}`}
        axios.get(pexelsApiUrl, { headers: headers})
        .then(handlePexelsResponse);
    } 

    function handleSubmit(event) {

        event.preventDefault();
        search();
    }

    function handleKeywordChange(event) {
        setKeyword(event.target.value);
    }

    function load() {
        setLoaded(true);
        search();
    }

    if (loaded) {
        return (
            <div className="Dictionary">
                <section id="id">
                <h1 > Choose a word to look up</h1>
                <form onSubmit={handleSubmit}>
                    <input type="search" 
                    onChange={handleKeywordChange} 
                    autoFocus={true}
                    defaultValue ={props.defaultKeyword}/>
                </form>
                <div className="hint">
                    suggested words: sunset, yoga, plant
                </div>
                </section>
                <br/>
                <Results results={results}/>
                <Photos photos={photos}/>
            </div>
        );
    } else {
        load();
        return "Loading";
    }
}